module.exports = __webpack_public_path__ + "static/media/th-TH.26abfac5.md";